import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { trackEvent } from '../utils/tracking';
import './Faq.css';

const ITEMS = [
  {
    q: 'I already get lounge access with my Faye policy. Is this different?',
    a: "It is. Your policy includes lounge access if your flight's delayed 3+ hours — a nice silver lining on a bad day. Travel+ passes work anytime, on any flight, no delay required. Walk in, sit down, enjoy.",
  },
  {
    q: 'Which lounges can I use?',
    a: 'Your pass works at {{LOUNGE_NETWORK_COUNT}} lounges worldwide through the Lounge Pass network. You’ll get the full list with your pass.',
  },
  {
    q: 'Will the eSIM work on my phone?',
    a: "If your phone is eSIM-compatible and unlocked, you're good. Most phones from the last few years are. Quick way to check: Settings → General → About → look for an EID number (iPhone), or search 'eSIM' in Settings (Android).",
  },
  {
    q: "I'm traveling with other people. Do we each need one?",
    a: 'Each bundle covers one traveler — one eSIM, one set of lounge visits. Use the traveler selector to grab bundles for your whole crew in one checkout.',
  },
  {
    q: 'When does everything arrive?',
    a: "Your eSIM QR code arrives within minutes of purchase. Your lounge pass comes in a separate email from Lounge Pass — if you don't see it, check spam before you panic.",
  },
  {
    q: 'What if I change my mind?',
    a: "You've got 14 days for a full refund, as long as nothing's been activated or redeemed. Once an eSIM is installed or a lounge pass is used, that part's non-refundable. Details in our refund policy.",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index, question) => {
    const isOpening = openIndex !== index;
    setOpenIndex(isOpening ? index : null);
    if (isOpening) trackEvent('FAQ Opened', { question });
  };

  return (
    <section className="tp-faq container">
      <h2 className="headline-2 tp-faq__title">Frequently asked questions</h2>
      <div className="tp-faq__list">
        {ITEMS.map((item, index) => {
          const open = openIndex === index;
          return (
            <div className="tp-faq__item" key={item.q}>
              <button
                type="button"
                className="tp-faq__question"
                aria-expanded={open}
                onClick={() => toggle(index, item.q)}
              >
                <span className="title-m">{item.q}</span>
                <ChevronDown
                  size={20}
                  strokeWidth={1.5}
                  className={`tp-faq__chevron${open ? ' tp-faq__chevron--open' : ''}`}
                />
              </button>
              {open && <p className="body-m tp-faq__answer">{item.a}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
